import { SalesConditionsUi } from '@/components/Seller/SellerProfile/SalesAndDelivery/SalesConditions/SalesConditionsUi';
import { SellerDetailsResponse } from '@/data/api/model/sellers/SellersDto';

export function sellerDetailsResponseToSalesConditionsUi(
  input: SellerDetailsResponse
): SalesConditionsUi {
  return {
    minPurchase:
      input.min_order_amount === undefined ? '' : `${input.min_order_amount}`,
    saveDisabled: true,
    cancelDisabled: true,
  };
}
